export default __webpack_public_path__ + "static/media/gamers.5e8c196d.jpg";